<div class="ss-wrap" [ngStyle]="themeVars">

	
	<div class="ss-icon-badge">
		<i class="material-icons">emoji_events</i>
	</div>

	
	<div class="ss-header">

		<div class="ss-title-group">
			<span class="ss-title">Sales Scoreboard</span>
			<span class="ss-subtitle" *ngIf="reportdata?.title">{{ reportdata.title }}</span>
		</div>

		<div class="ss-actions">
			<button class="ss-icon-btn" (click)="runreport()" [disabled]="!!reportrun" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
			<button class="ss-icon-btn" (click)="export('xlsx')" [disabled]="!!reportrun || !reportdata" title="Export Excel">
				<i class="fa fa-file-excel-o"></i>
			</button>
			<button class="ss-icon-btn" (click)="export('pdf')" [disabled]="!!reportrun || !reportdata" title="Export PDF">
				<i class="fa fa-file-pdf-o"></i>
			</button>
			<button class="ss-icon-btn" (click)="showdetails = !showdetails" [disabled]="!!reportrun" title="Expand Report">
				<i class="material-icons">expand_more</i>
			</button>
		</div>
        
	</div>


    


	
	<div class="ss-stats" *ngIf="reportdata && !reportrun">
		<div class="ss-stat">
			<span class="ss-stat-val">{{ totals?.sales  }}</span>
			<span class="ss-stat-lbl">Sales (Month)</span>
			<span class="ss-stat-chip" [ngClass]="{
				'is-up': totals?.salesdiff > 0,
				'is-down': totals?.salesdiff < 0,
				'is-flat': !totals?.salesdiff
			}">
				<i class="fa" [ngClass]="(totals?.salesdiff > 0) ? 'fa-long-arrow-up' : (totals?.salesdiff < 0) ? 'fa-long-arrow-down' : 'fa-minus'"></i>
				{{ totals?.salesdiffpercent }}%
			</span>
            <span class="ss-stat-lbl">{{totals?.salesly}}</span>
		</div>

		<div class="ss-stat">
			<span class="ss-stat-val">{{ totals?.salesytd }}</span>
			<span class="ss-stat-lbl">Sales (YTD)</span>
			<span class="ss-stat-chip" [ngClass]="{
				'is-up': totals?.salesytddiff > 0,
				'is-down': totals?.salesytddiff < 0,
				'is-flat': !totals?.salesytddiff
			}">
				<i class="fa" [ngClass]="(totals.salesytddiff > 0) ? 'fa-long-arrow-up' : (totals?.salesytddiff < 0) ? 'fa-long-arrow-down' : 'fa-minus'"></i>
				{{ totals?.salesytddiff }}
			</span>
            <span class="ss-stat-lbl">{{totals?.salesytdly}}</span>
		</div>

		<div class="ss-stat">
			<span class="ss-stat-val">{{ totals?.actives }}</span>
			<span class="ss-stat-lbl">Active Customers</span>
			<span class="ss-stat-chip" [ngClass]="{
				'is-up': totals?.activesdiff > 0,
				'is-down': totals?.activesdiff < 0,
				'is-flat': !totals?.activesdiff
			}">
				<i class="fa" [ngClass]="(totals?.activesdiff > 0) ? 'fa-long-arrow-up' : (totals?.activesdiff < 0) ? 'fa-long-arrow-down' : 'fa-minus'"></i>
				{{ totals?.activesdiff }}
			</span>
            <span class="ss-stat-lbl">{{totals?.activesly}}</span>
		</div>
	</div>



    <span class="ss-subtitle" *ngIf="reportdata?.subtitle && !reportrun">
        {{reportdata?.subtitle}}
    </span>

	
	<div class="ss-loading" *ngIf="reportrun">
		<svg class="spinner" width="40" height="40" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</div>




    <ng-container *ngIf="showdetails">
        <div class="ss-filters">
            <label class="ss-field">
                <span>Location</span>
                <mat-form-field>
                    <mat-select [formControl]="locationref" [disabled]="!!reportrun">
                        <mat-option *ngFor="let loc of allowedlocs" [value]="loc.value">{{ loc.view }}</mat-option>
                    </mat-select>
                </mat-form-field>

            </label>

            <label class="ss-field">
                <span>Month</span>
                <mat-form-field>
                    <mat-select [formControl]="monthref" [disabled]="!!reportrun">
                        <mat-option *ngFor="let m of months" [value]="m.value">{{ m.view }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>

            <label class="ss-field">
                <span>Year</span>
                <mat-form-field>
                    <mat-select [formControl]="yearref" [disabled]="!!reportrun" >
                        <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </label>

            <button class="ss-icon-btn pullright" (click)="runreport()" [disabled]="!!reportrun" title="Refresh">
				<i class="material-icons">refresh</i>
			</button>
        </div>


        
        <div class="ss-table-wrap" *ngIf="sortedData && !reportrun" #print_table>
            <table class="ss-table" matSort (matSortChange)="sortData($event)" >
                <thead>
                    <tr>
                        <th>Category</th>
                        <th mat-sort-header="actives" class="text-right">Active TY</th>
                        <th mat-sort-header="activesly" class="text-right">Active LY</th>
                        <th mat-sort-header="sales" class="text-right">Sales TY</th>
                        <th mat-sort-header="salesly" class="text-right">Sales LY</th>
                        <th mat-sort-header="salesdiffpercent" class="text-right">Sales Δ%</th>
                        <th mat-sort-header="salesytd" class="text-right">YTD TY</th>
                        <th mat-sort-header="salesytdly" class="text-right">YTD LY</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let row of sortedData">
                        <tr>
                            <td class="ss-cell-label">{{ row.name }}</td>
                            <td class="text-right">{{ row.actives }}</td>
                            <td class="text-right border-right">{{ row.activesly }}</td>
                            <td class="text-right">{{ row.sales  }}</td>
                            <td class="text-right">{{ row.salesly }}</td>
                            <td class="text-right border-right" [ngClass]="{ 'ss-pos': row.salesdiffpercent > 0, 'ss-neg': row.salesdiffpercent < 0}">
                                {{ row.salesdiffpercent  }}%
                            </td>   
                            <td class="text-right">{{ row.salesytd }}</td>
                            <td class="text-right">{{ row.salesytdly }}</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <div class="ss-empty" *ngIf="!reportdata && !reportrun">
            <i class="material-icons">emoji_events</i>
            <span>No scoreboard data yet.</span>
        </div>
    </ng-container>

</div>
